import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DatastoreRoutingModule } from './datastore-routing.module';
import { DatastoreComponent } from './datastore.component';
import { AppMaterialModule } from '../app.material.module';


@NgModule({
  declarations: [DatastoreComponent],
  imports: [
    CommonModule,
    DatastoreRoutingModule,
    AppMaterialModule
  ]
})
export class DatastoreModule { }
